// extracted by mini-css-extract-plugin
module.exports = {"errorHeader":"ReportErrorDialog_errorHeader__1c2ch","errorBody":"ReportErrorDialog_errorBody__3-eTy","errorModalBtn":"ReportErrorDialog_errorModalBtn__XNHbV"};